import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    loadContractRevenueRentLimitsStatus: 'idle',
    loadContractRevenueRentLimitsError: undefined as any,
    createContractRevenueRentLimitStatus: 'idle',
    createContractRevenueRentLimitError: undefined as any,
    updateContractRevenueRentLimitStatus: 'idle',
    updateContractRevenueRentLimitError: undefined as any,
    deleteContractRevenueRentLimitStatus: 'idle',
    deleteContractRevenueRentLimitError: undefined as any,

    fluklList: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,
}

export const loadContractRevenueRentLimits = createAsyncThunk('revenueRentLimitSlice/loadContractRevenueRentLimits', async (flust: any, { rejectWithValue }: any) => {
    const res = await client.get(`/api/ixweb/flukl/?USTID=${flust.HDR_ID}`)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return res.data.data
        }
    } else {  // backend response
        return res.data
    }
})
export const createContractRevenueRentLimit = createAsyncThunk('revenueRentLimitSlice/createContractRevenueRentLimit', async (flukl: any, { rejectWithValue }: any) => {
    const res = await client.post(`/api/ixweb/flukl/`, prepareData(flukl))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...flukl, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const updateContractRevenueRentLimit = createAsyncThunk('revenueRentLimitSlice/updateContractRevenueRentLimit', async (flukl: any, { rejectWithValue }: any) => {
    const res = await client.put(`/api/ixweb/flukl/${flukl.HDR_ID}/`, prepareData(flukl))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return flukl
        }
    } else {  // backend response
        return res.data
    }
})
export const deleteContractRevenueRentLimit = createAsyncThunk('revenueRentLimitSlice/deleteContractRevenueRentLimit', async (id: any, { rejectWithValue }: any) => {
    const res = await client.delete(`/api/ixweb/flukl/${id}/`)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return id
        }
    } else {  // backend response
        return id
    }
})

const FluklSlice = createSlice({
    name: 'revenueRentLimitSlice',
    initialState,
    reducers: {
        resetloadContractRevenueRentLimitsError: (state) => {
            state.loadContractRevenueRentLimitsError = undefined
        },
        resetcreateContractRevenueRentLimitError: (state) => {
            state.createContractRevenueRentLimitError = undefined
        },
        resetupdateContractRevenueRentLimitError: (state) => {
            state.updateContractRevenueRentLimitError = undefined
        },
        resetdeleteContractRevenueRentLimitError: (state) => {
            state.deleteContractRevenueRentLimitError = undefined
        },
        removeFromFluklListById: (state, action) => {
            state.fluklList = state.fluklList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractRevenueRentLimits.pending, (state) => {
            state.loadContractRevenueRentLimitsStatus = 'pending'
            state.loadContractRevenueRentLimitsError = undefined
        })
        builder.addCase(loadContractRevenueRentLimits.fulfilled, (state, action) => {
            state.loadContractRevenueRentLimitsStatus = 'idle'

            state.fluklList = action.payload
        })
        builder.addCase(loadContractRevenueRentLimits.rejected, (state, action) => {
            state.loadContractRevenueRentLimitsStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRevenueRentLimitsError = action.error.message
            } else {
                state.loadContractRevenueRentLimitsError = action.payload
            }
        })

        builder.addCase(createContractRevenueRentLimit.pending, (state) => {
            state.createContractRevenueRentLimitStatus = 'pending'
            state.createContractRevenueRentLimitError = undefined
        })
        builder.addCase(createContractRevenueRentLimit.fulfilled, (state, action) => {
            state.createContractRevenueRentLimitStatus = 'idle'

            state.fluklList = [...state.fluklList, action.payload]
        })
        builder.addCase(createContractRevenueRentLimit.rejected, (state, action) => {
            state.createContractRevenueRentLimitStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.createContractRevenueRentLimitError = action.error.message
            } else {
                state.createContractRevenueRentLimitError = action.payload
            }
        })

        builder.addCase(updateContractRevenueRentLimit.pending, (state) => {
            state.updateContractRevenueRentLimitStatus = 'pending'
            state.updateContractRevenueRentLimitError = undefined
        })
        builder.addCase(updateContractRevenueRentLimit.fulfilled, (state, action) => {
            state.updateContractRevenueRentLimitStatus = 'idle'

            const i = state.fluklList.findIndex((x: any) => x.HDR_ID === action.payload.HDR_ID)
            if (i === -1) { state.fluklList.push(action.payload) }
            else { state.fluklList[i] = { ...state.fluklList[i], ...action.payload } }
        })
        builder.addCase(updateContractRevenueRentLimit.rejected, (state, action) => {
            state.updateContractRevenueRentLimitStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.updateContractRevenueRentLimitError = action.error.message
            } else {
                state.updateContractRevenueRentLimitError = action.payload
            }
        })

        builder.addCase(deleteContractRevenueRentLimit.pending, (state) => {
            state.deleteContractRevenueRentLimitStatus = 'pending'
            state.deleteContractRevenueRentLimitError = undefined
        })
        builder.addCase(deleteContractRevenueRentLimit.fulfilled, (state, action) => {
            state.deleteContractRevenueRentLimitStatus = 'idle'

            state.fluklList = state.fluklList.filter((x: any) => x.HDR_ID !== action.payload)
        })
        builder.addCase(deleteContractRevenueRentLimit.rejected, (state, action) => {
            state.deleteContractRevenueRentLimitStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractRevenueRentLimitError = action.error.message
            } else {
                state.deleteContractRevenueRentLimitError = action.payload
            }
        })

    }
})

export const {
    resetloadContractRevenueRentLimitsError,
    resetcreateContractRevenueRentLimitError,
    resetupdateContractRevenueRentLimitError,
    resetdeleteContractRevenueRentLimitError,
    removeFromFluklListById,
    setFilterValues,
    setFilterLookupValue,
} = FluklSlice.actions
export default FluklSlice.reducer
